import React from 'react';
import Lightbox from "yet-another-react-lightbox";
import {Link} from 'react-router-dom';
import MetaTags from "../components/MetaTags";


const CircleBrelok: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        { src: "/image/Schema/tabletka_red_big.jpg" },
        { src: "/image/Schema/tabletka5_big.jpg" },
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Круглый брелок из бисера - схема плетения",
        "Круглый Брелок из бисера. Схема плетения брелока в технике квадратный столбик или объемный крестик."
    )

    return <>
        <h2>Круглый брелок из бисера - схема плетения</h2>
        <div className="row">
            <div className="col-md-12">
                    <img
                        src="/image/Schema/tabletka_red_small.jpg" className="pic-left img-rounded" width="112"
                        height="260" alt="Готовый брелок"
                        id="image-0"
                        onClick={viewImage}
                    />
                    <img
                        src="/image/Schema/tabletka5_small.jpg" className="pic-left img-rounded" width="112"
                        height="260"
                        alt="Готовый брелок"
                        id="image-1"
                        onClick={viewImage}
                    />
                <p>Брелок плетётся на основе объемного крестика или квадратного столбика.</p>
                <p>У меня получился брелок диаметром примерно 2,5 см.</p>
            </div>
        </div>
        <h4>Порядок плетения:</h4>

        <p>1. Сплести 11 кубиков в технике "<Link to="/kvadrat-stolbik">квадратный столбик</Link>" из бисера среднего размера.</p>
        <p>Одну грань можно сделать оранжевой, остальное голубого цвета.</p>

        <img src="/image/Schema/tabletka1.jpg" className="schema img-rounded col-centered img-responsive" width="483"
             height="200" alt=""/>
        <p>2. Соединить в кольцо.</p>
        <p>Один свободный конец лески выводим на внешнюю сторону колечка.</p>
        <img src="/image/Schema/tabletka2.jpg" className="schema img-rounded col-centered img-responsive" width="493"
             height="225" alt=""/>
        <p>3. Затем приплетаем кубик. И так далее сверху должен получиться еще один ряд квадратного столбика.</p>
        <p>Второй ряд оранжевый с темно-синим. Синие бисеринки нужно стараться
            подбирать более широкие и плоские, чтобы круг получился ровным.</p>

        <img src="/image/Schema/tabletka3.jpg" className="schema img-rounded col-centered img-responsive" width="529"
             height="195" alt=""/>
        <p>4. По краям пропустить бисерную нить - по две бисеринки между краевыми оранжевыми.</p>

        <img src="/image/Schema/tabletka4.jpg" className="schema img-rounded col-centered img-responsive" width="513"
             height="184" alt=""/>
        <p>5. Теперь можно приделать петельку.</p>
        <p>Брелок готов!</p>

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default CircleBrelok;

